'use client';

import {CardLinksFieldsFragment} from '@common/hygraph-schema';
import {Stack} from '@eds-web/react';
import {CardLink} from './CardLink.molecule';
import {css} from '@panda/css';

export const CardLinks = (props: CardLinksFieldsFragment) => {
	if (!props.items) {
		return null;
	}

	return (
		<Stack
			gap={16}
			noWrap
			direction="row"
			className={css({smDown: {flexDirection: 'column !important'}})}>
			{props.items.map((card, i) => (
				<CardLink key={i} {...card} />
			))}
		</Stack>
	);
};
